import { React, useState, useEffect, createContext, useMemo } from "react";
import request from "../../../Helpers/API";
import { Autocomplete, Button, Modal, Box, TextField, MenuItem, InputAdornment } from "@mui/material";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../helpers/PlantillaScreen";

const EditarFacturasnoContampladasModal = ({ open, onClose, documento }) => {
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    const [factura, setFactura] = useState({
        documento: null,
        comentario: "",
        estado: false,
        empleado: 0
    });

    const [isFieldsEnabled, setIsFieldsEnabled] = useState(false); // Estado para habilitar/deshabilitar campos

    useEffect(() => {
        if (documento) {
            setLoader({ ...loader, mostrar: true });
            request
            .get(`FacturasNoContemplar/InfoFactura?documento=${documento}`)
                .then((result) => {
                    setLoader({ ...loader, mostrar: false });
                    // console.log(result)
                    const facturaData = result[0];
                    setFactura({
                        documento: facturaData.documento || 0,
                        comentario: facturaData.comentarios || "",
                        estado: facturaData.estatus === "True"
                    });
                })
                .catch((error) => {
                    setLoader({ ...loader, mostrar: false });
                    console.error("Error al obtener los datos del cliente:", error);
                });
        }
    }, [documento]);


    const handleBuscar = (documento) => {
        setLoader({ ...loader, mostrar: true }); // Mostrar el loader
        request
            .get(`FacturasNoContemplar/Buscar?documento=${documento}`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false }); // Ocultar el loader
                if (result && result.length > 0) {
                    setIsFieldsEnabled(true); // Habilitar campos si hay resultados
                } else {
                    setIsFieldsEnabled(false); // Deshabilitar campos si no hay resultados
                    Swal.fire({
                        title: "FACTURAS NO CONTEMPLADAS",
                        text: "Documento no encontrado",
                        icon: "warning",
                        customClass: {
                            container: "mi-superpoop",
                        },
                    });
                }
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false }); // Ocultar el loader en caso de error
                console.error("Error fetching documentos:", error); // Manejo de errores
            });
    };

    const handleGuardar = () => {
        if (factura.documento === "" || factura.documento === null || factura.documento === undefined) {
            Swal.fire({
                title: "FACTURAS NO CONTEMPLADAS",
                text: "Debe seleccionar una factura",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (factura.comentario === "" || factura.comentario === null || factura.comentario === undefined) {
            Swal.fire({
                title: "FACTURAS NO CONTEMPLADAS",
                text: "Debe escribir un comentario",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        if (factura.estado === "" || factura.estado === null || factura.estado === undefined) {
            Swal.fire({
                title: "FACTURAS NO CONTEMPLADAS",
                text: "Debe seleccionar un estado para la factura",
                icon: "warning",
                customClass: {
                    container: "mi-superpoop",
                },
            });
            return;
        }

        const post = {
            documento: factura.documento,
            comentarios: factura.comentario,
            estatus: factura.estado,
            usuario: 0,
          };

        setLoader({ ...loader, mostrar: true });
        request
            .post("FacturasNoContemplar", post)
            .then(async (result) => {
                setLoader({ ...loader, mostrar: false });
                onClose();
                await Swal.fire({
                    title: "FACTURAS NO CONTEMPLADAS",
                    text: "Registro guardado con éxito",
                    icon: "success",
                    customClass: {
                        container: "mi-superpoop",
                    },
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("CLIENTES ESPECIALES", JSON.stringify(error), "error");
            });
    };

    // const handleSelectCliente = (id, razonSocial) => {
    //     setCliente({
    //         ...cliente,
    //         idCliente: id,
    //         razonSocial: razonSocial,
    //     });
    // };

    // console.log(cliente)
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="agregar-factura-nocontemplada-modal-formulario">
                    <div className="agregar-factura-nocontemplada-modal-plantilla">
                        <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                            <PlantillaScreen
                                titulo={"EDITAR FACTURA NO CONTEMPLADA"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>X</div>
                                <div className={`agregar-factura-nocontemplada-modal-agregar-convenio`}>
                                    <div className="agregar-factura-nocontemplada-modal-agregar-convenio-container scroll-4">
                                        <h3 className="titulo-seccion">Modificar Factura no Contemplada</h3>
                                        <Box display="flex" alignItems="center" sx={{ mt: 2 }}>
                                            <TextField
                                                id="outlined-documento"
                                                label="Documento"
                                                value={factura.documento}
                                                onChange={(e) => {
                                                    setFactura({
                                                        ...factura,
                                                        documento: e.target.value,
                                                    });
                                                }}
                                                sx={{ flexGrow: 1, mr: 1 }} // Flex para que ocupe el espacio disponible
                                                disabled // Deshabilitar el campo Documento
                                            />
                                            <Button
                                                variant="contained"
                                                onClick={() => handleBuscar(factura.documento)}
                                                disabled // Deshabilitar el botón Buscar
                                            >
                                                Buscar
                                            </Button>
                                        </Box>
                                        <TextField
                                            id="outlined-comentario"
                                            label="Comentario"
                                            sx={{ mt: 2 }}
                                            value={factura.comentario}
                                            onChange={(e) => {
                                                setFactura({
                                                    ...factura,
                                                    comentario: e.target.value,
                                                });
                                            }}
                                        />
                                        <TextField
                                            className="input-medio-comunicacion"
                                            fullWidth
                                            size="small"
                                            label="Estado"
                                            select
                                            type="text"
                                            value={factura.estado}
                                            onChange={(e) => {
                                                setFactura({
                                                    ...factura,
                                                    estado: e.target.value,
                                                });
                                            }}
                                            sx={{ mt: 2 }}
                                        >
                                            <MenuItem value={true}>Vigente</MenuItem>
                                            <MenuItem value={false}>Cancelado</MenuItem>
                                        </TextField>
                                    </div>
                                    <div className="agregar-factura-nocontemplada-modal-buttons">
                                        <Button
                                            variant="contained"
                                            className="agregar-factura-nocontemplada-modal-button-guardar"
                                            onClick={handleGuardar}
                                        >
                                            Guardar
                                        </Button>
                                    </div>
                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default EditarFacturasnoContampladasModal;